// BMIChildCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { BMI_Child_EndPoint } from "./ConstantsHealthCalculator";
import BMIChildrenTable from "./BMIChildrenTable";
import SharedHelmet from "../Helmet";
import growthchart_example2 from "./data/growthchart_example2.gif";
import imgUrl from "../../../images/bmi-children.webp";
const TITLE =
  "Kalkulator Indeks Massa Tubuh untuk Anak BMI - Kalkulator Berat Badan Ideal Anak";
const DESCRIPTION =
  "Gunakan kalkulator Indeks Massa Tubuh untuk anak untuk mengevaluasi kesehatan dan berat badan anak Anda - kalkulator BMI untuk anak adalah alat yang digunakan untuk mengevaluasi apakah berat badan anak sesuai dengan tinggi badannya yaitu berat badan ideal (BMI) anak Anda";
const KEYWORDS =
  "indeks massa tubuh untuk anak, hitung BMI untuk anak, kalkulator BMI untuk anak, cara menghitung indeks massa tubuh untuk anak, berat badan ideal, rumus hitung BMI untuk anak, indikator kesehatan anak dan massa tubuh, ketahui BMI anak saya, BMI sehat untuk anak, analisis BMI dan berat badan sehat untuk anak, cara mengevaluasi BMI untuk anak";
const OG_URL = "https://do-calculate.com/calculator/id/bmichildren/";
const apiEndpoint = `${SERVER_URL}/${BMI_Child_EndPoint}`;
function BMICalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const calculateBMI = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, height, age, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
        <div className="col-12 col-md-4 text-center">
          <img src={imgUrl} alt={TITLE} style={{ width: '312px', height: '312px' }} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator Indeks Massa Tubuh untuk anak adalah alat yang digunakan untuk mengevaluasi dan menghitung apakah berat badan anak sesuai dengan tinggi badannya, yaitu berat badan ideal anak. Untuk menghitung massa tubuh untuk anak, kalkulator ini menggunakan kategori BMI yang digunakan untuk anak-anak dan remaja berusia 2 hingga 20 tahun. Kalkulator memperhitungkan usia, jenis kelamin, tinggi badan, dan berat badan untuk menghitung BMI anak. BMI anak disajikan sebagai persentil, dan angka persentil menunjukkan bagaimana berat badan anak dibandingkan dengan anak-anak lain seusia dan jenis kelamin yang sama.
                <br />
                Kalkulator ini juga menampilkan tabel BMI untuk anak laki-laki dan perempuan yang disetujui oleh Badan Kesehatan Masyarakat Nasional Amerika Serikat.
                <br />
                <b >
                  Tanggal Pembaruan Terakhir:{" "}
                  <time dateTime="2026-01-10">28/02/2026</time>
                </b>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Indeks Massa Tubuh untuk Anak BMI
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Tinggi Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Berat Badan
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      Usia
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                  <span style={{ marginRight: "10px" }}>
                    (antara 2 hingga 20 tahun)
                  </span>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >Jenis Kelamin</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      id="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      Laki-laki
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      id="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      Perempuan
                    </label>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBMI}
                         >
                    Hitung
                    </button>                </div>
              </div>
              <div className="col-12 col-md-7">
                <BMIChildrenTable
                  classification={classification}
                ></BMIChildrenTable>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>{" "}
                    Harap masukkan semua kolom dengan benar.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>Hasil:</h4>
                    <hr />
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      <label>
                        <b> Indeks Massa Tubuh (BMI) : </b>
                        {result.bmi} <label> kg/m²</label>
                      </label>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      <label>
                        <b> Klasifikasi: </b> {result.classification}
                      </label>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      <label>
                        <b> Persentil: </b>
                        {result.centile}
                      </label>
                    </div>
                    {result.weightNeeded !== 0 && (
                      <div>
                        <div
                          style={{
                            backgroundColor: "#D1E7DD",
                            borderColor: "#c3e6cb",
                            color: "#155724",
                            padding: "15px",
                            marginBottom: "20px",
                            borderRadius: "4px",
                          }}
                        >
                          {" "}
                          <label>
                            <b> Kisaran BMI Sehat: </b>
                            {result.lowerHealthyBMI} - {result.higherHealthyBMI}{" "}
                            (kg/m²)
                          </label>
                        </div>
                        {result.weightNeeded > 0 && (
                          <div
                            style={{
                              backgroundColor: "#D1E7DD",
                              borderColor: "#c3e6cb",
                              color: "#155724",
                              padding: "15px",
                              marginBottom: "20px",
                              borderRadius: "4px",
                            }}
                          >
                            {" "}
                            <label>
                              Naikkan: <b> " {result.weightNeeded} kg "</b> untuk mencapai BMI{" "}
                              <b> {result.lowerHealthyBMI} (kg/m²) </b>
                            </label>
                          </div>
                        )}
                        {result.weightNeeded < 0 && (
                          <div
                            style={{
                              backgroundColor: "#D1E7DD",
                              borderColor: "#c3e6cb",
                              color: "#155724",
                              padding: "15px",
                              marginBottom: "20px",
                              borderRadius: "4px",
                            }}
                          >
                            {" "}
                            <label>
                              Turunkan:{" "}
                              <b> " {Math.abs(result.weightNeeded)} kg "</b> untuk mencapai BMI{" "}
                              <b> {result.higherHealthyBMI} (kg/m²) </b>
                            </label>
                          </div>
                        )}
                        <div className="alert alert-warning">
                          <label>
                            {" "}
                            Jika Anda ingin mendiskusikan berat badan anak Anda, bicarakan dengan perawat sekolah anak Anda atau dokter umum.
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                {" "}
                Hitung Indeks Massa Tubuh BMI (Anak) - Berat Badan Ideal Anak
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Hitung Indeks Massa Tubuh BMI (Anak) - Ukur Kesehatan dan Berat Badan Anak Anda dengan Akurat{" "}
                  </h2>{" "}
                </u>
                <p>
                  BMI anak memberi tahu kita apakah berat badannya sesuai dengan tinggi badannya. Alih-alih menggunakan kategori BMI yang digunakan untuk orang dewasa, BMI anak diberikan sebagai persentil. Karena anak-anak terus tumbuh hingga sekitar usia 20 tahun, usia mereka dan apakah mereka laki-laki atau perempuan juga digunakan untuk menghitung persentil BMI.
                </p>
                <p>
                  Untuk anak-anak dan remaja berusia 2 hingga 20 tahun, kalkulator BMI memperhitungkan usia dan jenis kelamin serta tinggi dan berat badan.
                </p>
                <p>
                  BMI anak diberikan sebagai "persentil". Angka persentil menunjukkan bagaimana BMI dibandingkan dengan anak-anak lain seusia dan jenis kelamin yang sama sebagai persentase.
                </p>
                <div className="p-3 mb-2 bg-info  ">
                  <p>
                    Misalnya, seorang anak perempuan di persentil 75 berarti dia lebih berat daripada 75% anak perempuan lain seusianya.
                  </p>
                </div>
                <p>
                  Dalam kalkulator ini, kami menggunakan klasifikasi BMI untuk anak-anak dan remaja berusia 2 hingga 20 tahun yang direkomendasikan oleh <u>"Pusat Pengendalian dan Pencegahan Penyakit (CDC)"</u> dari Badan Kesehatan Masyarakat Nasional Amerika Serikat yang kami sebutkan dalam tabel sebelumnya.
                </p>
                <h2 style={{ fontSize: "16px" }}>
                  Grafik BMI untuk Anak-anak dan Remaja, usia 2 hingga 20 tahun:{" "}
                </h2>{" "}
                <br />
                Grafik pertumbuhan persentil CDC:
                <ul>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c021.pdf">
                      Grafik untuk Laki-laki
                    </a>
                  </li>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c022.pdf">
                      Grafik untuk Perempuan
                    </a>
                  </li>
                </ul>
                <h2 style={{ fontSize: "16px" }}>
                  {" "}
                  Tabel BMI untuk Anak berdasarkan Usia yang Disetujui dalam Kalkulator Ini untuk Menghitung Persentil:
                </h2>
                <ul>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c023.pdf">
                      Laki-laki{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c024.pdf">
                      Perempuan{" "}
                    </a>
                  </li>
                </ul>
                <div className="p-3 mb-2 bg-info ">
                  Persentil ini menyatakan BMI anak relatif terhadap anak-anak Amerika yang berpartisipasi dalam survei nasional dari 1963-1965 hingga 1988-1994. Karena kami tidak menemukan grafik tentang BMI anak relatif terhadap anak-anak di negara-negara Arab, kami mengandalkan data Amerika.
                </div>
                <br />                <b>Sumber: </b>
                <a href="https://www.cdc.gov/bmi/faq/">
                  Pusat Pengendalian dan Pencegahan Penyakit - Badan Kesehatan Masyarakat Nasional Amerika Serikat
                </a>{" "}
                <br />
                <b>Tanggal peninjauan terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-12 col-md-8">
          <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum:</h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana BMI digunakan dengan anak-anak dan remaja?
                </h3>
              </div>
              <div className="info-section-body">
                Untuk anak-anak dan remaja, BMI digunakan untuk menyaring potensi masalah terkait berat badan dan kesehatan. Jika anak-anak atau remaja memiliki BMI yang tinggi untuk usia dan jenis kelamin mereka, penyedia layanan kesehatan dapat melakukan penilaian tambahan seperti mengukur ketebalan lipatan kulit, mengevaluasi riwayat keluarga, pola makan, dan aktivitas fisik. American Academy of Pediatrics merekomendasikan penggunaan BMI untuk menyaring kelebihan berat badan dan obesitas pada anak-anak mulai usia 2 tahun. Untuk anak di bawah 2 tahun, silakan merujuk ke{" "}
                <a href="https://www.who.int/childgrowth/standards/en/">
                  standar Organisasi Kesehatan Dunia (WHO)
                </a>
                .
                <br />
                BMI-untuk-usia untuk anak-anak dan remaja harus diperiksa setidaknya setahun sekali, tetapi penyedia layanan kesehatan dapat memeriksanya lebih sering. Melacak pola pertumbuhan dari waktu ke waktu dapat membantu memastikan bahwa anak atau remaja mencapai atau mempertahankan berat badan yang sehat. Menghitung BMI-untuk-usia sekali saja tidak cukup untuk mengevaluasi status berat badan jangka panjang, karena tinggi dan berat badan anak-anak dan remaja akan berubah seiring pertumbuhan mereka.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  Mengapa kisaran berat badan sehat tidak dapat diberikan untuk anak-anak dan remaja seperti halnya untuk orang dewasa?
                </h3>
              </div>
              <div className="info-section-body">
                Untuk anak-anak dan remaja, berat badan sehat didasarkan pada BMI antara persentil ke-5 dan ke-85 pada grafik pertumbuhan CDC. Sulit untuk menentukan kisaran berat badan sehat untuk anak-anak dan remaja karena interpretasi BMI tergantung pada berat badan, tinggi badan, usia, dan jenis kelamin. Untuk orang dewasa, interpretasi BMI hanya didasarkan pada tinggi dan berat badan.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  Bagaimana saya tahu jika anak saya kelebihan berat badan atau obesitas?{" "}
                </h3>
              </div>
              <div className="info-section-body">
                Kelebihan berat badan pada anak-anak dan remaja didefinisikan ketika BMI antara persentil ke-85 dan kurang dari persentil ke-95. Obesitas pada anak-anak dan remaja didefinisikan ketika BMI pada atau di atas persentil ke-95 untuk anak-anak dan remaja seusia dan jenis kelamin yang sama.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  Kedua anak saya memiliki nilai BMI yang sama, tetapi penyedia layanan kesehatan menganggap satu obesitas dan yang lainnya tidak. Mengapa demikian?{" "}
                </h3>
              </div>
              <div className="info-section-body">
                Interpretasi BMI bervariasi menurut usia dan jenis kelamin. Oleh karena itu, jika anak-anak tidak seusia dan berjenis kelamin sama, interpretasi BMI memiliki arti yang berbeda. Lihat ilustrasi berikut untuk anak laki-laki berusia 10 tahun dan anak laki-laki berusia 15 tahun yang keduanya memiliki BMI 23. (Perhatikan bahwa dua anak dari berbagai usia diplot pada grafik pertumbuhan yang sama untuk mengilustrasikan suatu titik. Biasanya, pengukuran hanya diplot untuk satu anak pada grafik pertumbuhan.)
                <div>
                  <img
                    src={growthchart_example2}
                    alt="growthchart_example2"
                    loading="lazy"
                  ></img>
                </div>
                <br />
                <b>Sumber: </b>
                <a href="https://www.cdc.gov/healthyweight/assessing/bmi/childrens_bmi/about_childrens_bmi.html">
                  Pusat Pengendalian dan Pencegahan Penyakit - Badan Kesehatan Masyarakat Nasional Amerika Serikat
                </a>{" "}
                <br />
                <b>Tanggal peninjauan terakhir : </b>
                28/02/2026
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa itu tabel BMI untuk anak-anak dan remaja dan bagaimana cara menggunakannya?
                </h3>
              </div>
              <div className="info-section-body">
                Tabel BMI untuk anak-anak dan remaja adalah alat yang digunakan untuk memperkirakan seberapa gemuk atau kurusnya anak-anak dan remaja berdasarkan berat dan tinggi badan. Tabel ini digunakan untuk memahami apakah anak atau remaja berkembang secara sehat dalam hal berat dan tinggi badan.
                <br />
                Tabel ini mencakup serangkaian kurva dan indikator yang mengukur posisi individu relatif terhadap teman sebayanya yang seusia dan berjenis kelamin sama. BMI untuk anak-anak dan remaja digunakan untuk menentukan apakah berat badan individu saat ini berada dalam kisaran normal, atau jika ada akumulasi lemak berlebih atau kekurangan berat badan.
                <br />
                Perhatikan bahwa konsep obesitas dan kurus tergantung pada usia dan jenis kelamin, sehingga faktor-faktor ini harus dipertimbangkan saat menggunakan tabel. Tabel BMI untuk anak-anak dan remaja digunakan oleh dokter dan profesional kesehatan untuk memperkirakan kesehatan fisik dan memandu pengobatan jika perlu.
                <br />
                Orang tua didorong untuk mendiskusikan hasil tabel BMI dengan dokter anak mereka untuk lebih memahami kesehatan anak-anak mereka dan mengambil tindakan yang tepat jika perlu.
                <br />
                Anda dapat mengunduh tabel BMI untuk anak-anak yang disetujui oleh Kementerian Kesehatan Dunia melalui{" "}
                <a href="https://www.who.int/toolkits/child-growth-standards/standards/body-mass-index-for-age-bmi-for-age">
                  klik di sini
                </a>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa itu tabel berat badan normal untuk anak laki-laki dan perempuan
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Tabel berat badan normal untuk laki-laki dan perempuan dapat membantu mengetahui persentil di mana berat badan anak mereka berada. Misalnya, jika berat badan mereka pada persentil keenam puluh, itu berarti 40% anak-anak seusia dan jenis kelamin yang sama memiliki berat lebih, dan 60% dari anak-anak tersebut memiliki berat kurang.
                </p>
                <p>
                  Itu tidak selalu berarti bahwa anak tersebut kelebihan atau kekurangan berat badan. Ini hanya dapat menunjukkan di mana letak berat badan anak pada spektrum.
                </p>
                <p>
                  Tabel di bawah ini menunjukkan berat badan anak pada persentil ke-50. Ini adalah berat rata-rata. Anak laki-laki cenderung sedikit lebih berat daripada anak perempuan, sehingga tabel dibagi berdasarkan jenis kelamin.
                </p>
                Berikut adalah tabel berat badan normal untuk anak laki-laki dan perempuan
                <table >
                  <thead>
                    <tr>
                      <th className="formula-header">Usia</th>
                      <th className="formula-header">Perempuan</th>
                      <th className="formula-header">Laki-laki</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Lahir</td>
                      <td>3,2 kg (7 lb 2 oz)</td>
                      <td>3,3 kg (7 lb 6 oz)</td>
                    </tr>
                    <tr>
                      <td>1 bulan</td>
                      <td>4,2 kg (9 lb 4 oz)</td>
                      <td>4,5 kg (9 lb 14 oz)</td>
                    </tr>
                    <tr>
                      <td>2 bulan</td>
                      <td>5,1 kg (11 lb 5 oz)</td>
                      <td>5,6 kg (12 lb 4 oz)</td>
                    </tr>
                    <tr>
                      <td>3 bulan</td>
                      <td>5,8 kg (12 lb 14 oz)</td>
                      <td>6,4 kg (14 lb 1 oz)</td>
                    </tr>
                    <tr>
                      <td>4 bulan</td>
                      <td>6,4 kg (14 lb 3 oz)</td>
                      <td>7,0 kg (15 lb 7 oz)</td>
                    </tr>
                    <tr>
                      <td>5 bulan</td>
                      <td>6,9 kg (15 lb 3 oz)</td>
                      <td>7,5 kg (16 lb 9 oz)</td>
                    </tr>
                    <tr>
                      <td>6 bulan</td>
                      <td>7,3 kg (16 lb 1 oz)</td>
                      <td>7,9 kg (17 lb 8 oz)</td>
                    </tr>
                    <tr>
                      <td>7 bulan</td>
                      <td>7,6 kg (16 lb 14 oz)</td>
                      <td>8,3 kg (18 lb 5 oz)</td>
                    </tr>
                    <tr>
                      <td>8 bulan</td>
                      <td>7,9 kg (17 lb 8 oz)</td>
                      <td>8,6 kg (18 lb 15 oz)</td>
                    </tr>
                    <tr>
                      <td>9 bulan</td>
                      <td>8,2 kg (18 lb 2 oz)</td>
                      <td>8,9 kg (19 lb 10 oz)</td>
                    </tr>
                    <tr>
                      <td>10 bulan</td>
                      <td>8,5 kg (18 lb 11 oz)</td>
                      <td>9,2 kg (20 lb 3 oz)</td>
                    </tr>
                    <tr>
                      <td>11 bulan</td>
                      <td>8,7 kg (19 lb 4 oz)</td>
                      <td>9,4 kg (20 lb 12 oz)</td>
                    </tr>
                    <tr>
                      <td>12 bulan</td>
                      <td>8,9 kg (19 lb 12 oz)</td>
                      <td>9,6 kg (21 lb 4 oz)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  Apakah BMI diinterpretasikan dengan cara yang sama untuk anak-anak dan remaja seperti untuk orang dewasa?
                </h3>
              </div>
              <div className="info-section-body">
                BMI diinterpretasikan secara berbeda untuk anak-anak dan remaja meskipun dihitung dengan rumus yang sama. Karena perubahan berat dan tinggi seiring bertambahnya usia, serta hubungannya dengan obesitas tubuh, tingkat BMI pada anak-anak dan remaja dinyatakan dibandingkan dengan anak-anak lain dari jenis kelamin dan usia yang sama. Persentil ini dihitung dari grafik pertumbuhan CDC, yang didasarkan pada data survei nasional yang dikumpulkan dari 1963-1965 hingga 1988-1994.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BMICalculator;